export default __webpack_public_path__ + "static/media/menuRenomear.2ad695e7.svg";